import { useMutation, useQuery } from "@tanstack/react-query";

import { APIs } from "../api/APIs";
import { api } from "../api";

export const useUser = () => {
  const useGetUserProfile = (keys, select) => {
    const { userId } = keys;
    const api_info = APIs.user.view(userId);
    return useQuery({
      queryKey: ["/user/{userId}", keys],
      queryFn: async () => await api(api_info),
      refetchOnWindowFocus: false,
      select,
      enabled: !!userId,
      staleTime: 60 * 60,
    });
  };

  const updateInfoMutation = useMutation({
    mutationFn: async (keys) => {
      const { payload, userId } = keys;

      const api_info = APIs.user.update_info(userId, payload);
      const response = await api(api_info);
      return response.data;
    },
  });

  const changeEmailMutation = useMutation({
    mutationFn: async (keys) => {
      const { payload, userId } = keys;

      const api_info = APIs.user.change_email(userId, payload);
      const response = await api(api_info);
      return response.data;
    },
  });

  const changePasswordMutation = useMutation({
    mutationFn: async (keys) => {
      const { payload, userId } = keys;

      const api_info = APIs.user.change_password(userId, payload);
      const response = await api(api_info);
      return response.data;
    },
  });

  const withdrawMutation = useMutation({
    mutationFn: async (keys) => {
      const api_info = APIs.user.withdraw(keys);
      const response = await api(api_info);
      return response.data;
    },
  });

  return {
    useGetUserProfile,
    updateInfoMutation,
    changeEmailMutation,
    changePasswordMutation,
    withdrawMutation,
  };
};
